import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Assets/Css/ourteam.css";
import {
  FaUserTie,
  FaHardHat,
  FaCalculator,
  FaUserCog,
  FaUserCheck,
} from "react-icons/fa";
import { MdEngineering, MdOutlineManageAccounts, MdWork } from "react-icons/md";
import { Helmet } from "react-helmet";
import organizationchart from "../Assets/Images/organizationchart1.png";

import rahulImg from "../Assets/Images/RAHUL GAWADE-DIRECTOR.jpg";
import NewsushilImg from '../Assets/Images/new-sushil-kumar.jpeg';
import amitJoshiImg from "../Assets/Images/Amit Joshi.jpg";
import dilipImg from "../Assets/Images/Dilip Mevada-SR. EXECUTIVE.jpg";
import harshalImg from "../Assets/Images/Harshal Gaikwad-FINANCE & ACCOUNTS.jpeg";
import deepakImg from "../Assets/Images/Deepak Rajput-OFFICER PURCHASER.jpeg";
import visheshImg from "../Assets/Images/VISHESH KUMAR DHIMAN-MANAGER PLANNING & BILLING.jpg";
import praveshImg from "../Assets/Images/dummymanface.png";
import jaydeepImg from "../Assets/Images/dummymanface.png";
import amitSinghImg from "../Assets/Images/dummymanface.png";
import shekharImg from "../Assets/Images/Shekhar Pardeshi_Passport Photo.jpeg";
import kiranImg from "../Assets/Images/Kiran Khairnar_Passport Photo.jpg";
import kamleshImg from "../Assets/Images/Kamleshphoto.jpg";

// const keyPersons = [
//   { name: 'RAHUL MADHUKAR GAWADE', role: 'DIRECTOR' },
//   { name: 'SUSHIL KUMAR', role: 'DIRECTOR' },
//   { name: 'AMIT JOSHI', role: 'CIVIL ENGINEER' },
//   { name: 'DILIP MEVADA', role: 'SR. EXECUTIVE' },
//   { name: 'HARSHAL GAIKWAD', role: 'FINANCE & ACCOUNTS' },
//   { name: 'DEEPAK RAJPUT', role: 'OFFICER PURCHASER' },
//   { name: 'VISHESH KUMAR DHIMAN', role: 'MANAGER PLANNING & BILLING' },
//   { name: 'PRAVESH DHIMAN', role: 'SITE ENGINEER' },
//   { name: 'JAYDEEP SINGH', role: 'HR DEPARTMENT' },
//   { name: 'KAMLESH PATNE', role: 'HR DEPARTMENT' },
//   { name: 'AMIT SINGH', role: 'QA/QC ENGINEER' },

//   { name: 'KIRAN KHAIRNAR', role: 'CIVIL ENGINEER' },
//   { name: 'SHEKHAR PARDESHI', role: 'Executive' },

// ];

const keyPersons = [
  // Directors
 { name: "RAHUL MADHUKAR GAWADE", role: "DIRECTOR" },
{ name: "SUSHIL KUMAR", role: "DIRECTOR" },
{ name: "KIRAN KHAIRNAR", role: "DEPUTY MANAGER - CIVIL DEPARTMENT" },
{ name: "DILIP MEVADA", role: "SR. GM HSE DEPARTMENT" },
{ name: "SHEKHAR PARDESHI", role: "GM - CONTRACTS & TENDER DEPARTMENT" },
{ name: "KAMLESH PATNE", role: "HR DEPARTMENT" },
{ name: "HARSHAL GAIKWAD", role: "FINANCE & ACCOUNTS" },
{ name: "DEEPAK RAJPUT", role: "OFFICER PURCHASER" },
{ name: "VISHESH KUMAR DHIMAN", role: "MANAGER PLANNING & BILLING" },
{ name: "AMIT JOSHI", role: "CIVIL ENGINEER" },
{ name: "JAYDEEP SINGH", role: "HR DEPARTMENT" },
{ name: "PRAVESH DHIMAN", role: "SITE ENGINEER" },
{ name: "AMIT SINGH", role: "QA/QC ENGINEER" },


];

const personImages = {
  "RAHUL MADHUKAR GAWADE": rahulImg,
  "SUSHIL KUMAR": NewsushilImg,
  "AMIT JOSHI": amitJoshiImg,
  "DILIP MEVADA": dilipImg,
  "HARSHAL GAIKWAD": harshalImg,
  "DEEPAK RAJPUT": deepakImg,
  "VISHESH KUMAR DHIMAN": visheshImg,
  "PRAVESH DHIMAN": praveshImg,
  "JAYDEEP SINGH": jaydeepImg,
  "AMIT SINGH": amitSinghImg,
  "SHEKHAR PARDESHI": shekharImg,
  "KIRAN KHAIRNAR": kiranImg,
  "KAMLESH PATNE": kamleshImg,
};

const otherWorkers = [
  {
    name: "PANKAJ KUMAR",
    role: "ELECTRICIAN",
    qualification: "GRADUATE/ITI",
    experience: "12 Years",
  },
  {
    name: "MANOJ KUMAR",
    role: "FITTER/WELDER",
    qualification: "ITI",
    experience: "10 Years",
  },
  {
    name: "MOHD. HUMAYUN",
    role: "ARCH WELDER",
    qualification: "5TH",
    experience: "08 Years",
  },
  {
    name: "ANKIT SAINI",
    role: "MIG WELDER",
    qualification: "12TH",
    experience: "05 Years",
  },
  {
    name: "MOHD. JASID",
    role: "ARCH WELDER",
    qualification: "8TH",
    experience: "07 Years",
  },
  {
    name: "MANTU KUMAR",
    role: "WELDER",
    qualification: "ITI",
    experience: "10 Years",
  },
  {
    name: "SHYAM BABU",
    role: "GAS CUTTER",
    qualification: "HIGH SCHOOL",
    experience: "08 Years",
  },
  {
    name: "RANJIT SINGH",
    role: "GAS CUTTER",
    qualification: "HIGH SCHOOL",
    experience: "06 Years",
  },
  {
    name: "MOHD. NISHAT ALAM",
    role: "TACK WELDER/ GRINDER",
    qualification: "GRADUATE",
    experience: "04 Years",
  },
  {
    name: "MOHD. NASEEM",
    role: "GRINDER",
    qualification: "8TH",
    experience: "03 Years",
  },
  {
    name: "RAJU",
    role: "HELPER",
    qualification: "5TH",
    experience: "03 Years",
  },
  {
    name: "RAJIV SINGH",
    role: "HELPER",
    qualification: "9TH",
    experience: "02 Years",
  },
  {
    name: "KUNAL THAKUR",
    role: "HELPER",
    qualification: "10TH",
    experience: "03 Years",
  },
  {
    name: "VIJAY KUMAR",
    role: "HELPER",
    qualification: "8TH",
    experience: "06 Years",
  },
  {
    name: "NADEEM KHAN",
    role: "RIGGER",
    qualification: "8TH",
    experience: "06 Years",
  },
  {
    name: "RAJESH SINGH",
    role: "RIGGER",
    qualification: "5TH",
    experience: "04 Years",
  },
];

const toolsList = [
  { id: 1, name: "32MM VERTICLE DRILLING MACHINE", quantity: "01" },
  { id: 2, name: "25MM VERTICLE DRILLING MACHINE", quantity: "01" },
  { id: 3, name: "ARC/TIG WELDING MACHINE (3 Phase)", quantity: "02" },
  { id: 4, name: "ARC/TIG WELDING MACHINE (1 Phase)", quantity: "02" },
  { id: 5, name: "MIG WELDING MACHINE", quantity: "01" },
  { id: 6, name: "PLASMA CUTTING MACHINE", quantity: "01" },
  { id: 7, name: "BOSCH MAKE 14’’ CUT OFF MACHINE (CHOP-SAW)", quantity: "04" },
  { id: 8, name: "GAS CUTTING SET", quantity: "02" },
  { id: 9, name: "PUG CUTTING MACHINE", quantity: "02" },
  { id: 10, name: "4’’ ANGLE GRINDER", quantity: "06" },
  { id: 11, name: "7” ANGLE GRINDER", quantity: "04" },
  { id: 12, name: "SPRAY PAINT COMPRESSURE", quantity: "02" },
  { id: 13, name: "WELDING GUAGE", quantity: "02" },
  { id: 14, name: "CENTER PUNCH", quantity: "05" },
  { id: 15, name: "HAMMER 2Kg & 5 Kg", quantity: "02 Nos. EACH" },
  {
    id: 16,
    name: "WELDING POWER CONNECTION CABLE (50 MTRS. EACH)",
    quantity: "10 Nos.",
  },
  { id: 17, name: "WELDING HOLDER CABLE (25 MTRS EACH)", quantity: "10 Nos." },
  { id: 18, name: "WELDING EARTH CABLE (10 MTRS EACH)", quantity: "10 Nos." },
  {
    id: 19,
    name: "JUNCTION BOX WITH MAIN BOARD (63 Amps.)",
    quantity: "02 Nos.",
  },
  {
    id: 20,
    name: "WELDING HELMAT WITH GLASS (BLACK & WHITE)",
    quantity: "10 Nos.",
  },
  { id: 21, name: "RING SPANNER (ASSORTED SIZES)", quantity: "20 Nos." },
  { id: 22, name: "DOUBLE END SPANNER (ASSORTED SIZES)", quantity: "20 Nos." },
  { id: 23, name: 'TRI-SQUIRE (6", 9", 12")', quantity: "02 Nos. EACH" },
  { id: 24, name: 'SCREW DRIVERS (9", 12")', quantity: "02 Nos. EACH" },
  { id: 25, name: "SCREW SPANNERS", quantity: "03 Nos." },
  { id: 26, name: "CUTTING PLIER", quantity: "03 Nos." },
  { id: 27, name: "SPRIT LEVEL", quantity: "05 Nos." },
  { id: 28, name: "CHIPPING CHIESEL", quantity: "10 Nos." },
  {
    id: 29,
    name: "CUTTING TORCH WITH HOSE PIPE-RED & BLUE (12MTRS)",
    quantity: "07 Nos.",
  },
  { id: 30, name: "OXYGEN REGULATORS", quantity: "07 Nos." },
  { id: 31, name: "LPG REGULATORS", quantity: "07 Nos." },
  { id: 32, name: "CHIPPING HAMMERS", quantity: "05 Nos." },
];

export default function OurTeam() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        <title>
          Our Team | Skilled Engineers & Dedicated Workers | Samashree
          Enterprises
        </title>
        <meta
          name="description"
          content="Meet the driving force behind Samashree Enterprises — from visionary directors and skilled engineers to experienced welders, riggers, and helpers. Discover our machinery and workforce capabilities."
        />
        <meta
          name="keywords"
          content="Samashree team, civil engineers, welders, riggers, skilled workers, machinery list, site workers, directors, fabrication, construction team"
        />
        <link
          rel="canonical"
          href="https://www.samashreeenterprises.com/our-team"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section8">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Our Team, Your Strength</h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Skilled engineers, dedicated workers, and visionary leaders
            delivering excellence.
          </p>
        </div>
      </section>

      <section className="py-5">
        <Container>
          <h2 className="page-title" data-aos="fade-up">
            Organization chart
          </h2>

          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <img
                src={organizationchart}
                alt="Organization Chart"
                style={{ height: "350px" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      <div className="ourteam-container">
        <div className="team-section py-5">
          <Container>
            <h2 className="page-title" data-aos="fade-up">
              Key Persons
            </h2>

            <Row className="g-4 mb-5 justify-content-center">
              {keyPersons.map((person, idx) => (
                <Col
                  key={idx}
                  xs={12}
                  sm={12}
                  md={3}
                  className="d-flex justify-content-center"
                >
                  <Card className="keyteam-card fixed-card">
                    <Card.Body className="d-flex flex-column justify-content-center text-center">
                      <div className="mb-2 role-image">
                        <img
                          src={personImages[person.name]}
                          alt={person.name}
                          className="person-photo"
                        />
                      </div>
                      <Card.Title className="keyteam-name">
                        {person.name}
                      </Card.Title>
                      <Card.Text className="keyteam-role">
                        {person.role}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <h2 className="page-title" data-aos="fade-up">
              Other Key Workers
            </h2>
            <Row className="g-4">
              {otherWorkers.map((worker, idx) => (
                <Col key={idx} md={3} sm={6} xs={6}>
                  <Card className="team-card shadow-sm">
                    <Card.Body>
                      <Card.Title className="team-name">
                        {worker.name}
                      </Card.Title>
                      <Card.Text>
                        <strong>Designation:</strong> {worker.role}
                        <br />
                        <strong>Qualification:</strong> {worker.qualification}
                        <br />
                        <strong>Experience:</strong> {worker.experience}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>

      <section className="machinery-section py-4">
        <Container>
          <h2 className="page-title" data-aos="fade-up">
            Note
          </h2>
          <p className="">
            • We have separate staff for Steel Structure Erection purpose.{" "}
            <br />• We have sufficient number of skilled and unskilled labour
            force for security services and other work mentioned above.
          </p>

          <h2 className="page-title mt-5" data-aos="fade-up">
            List of Machineries
          </h2>

          <div
            className="machinery-table-wrapper"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <table className="machinery-table">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Machines</th>
                  <th>Nos.</th>
                </tr>
              </thead>

              <tbody>
                {toolsList.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </div>
  );
}
